import { Button, createStyles, Link, makeStyles, MenuItem, Select, Theme, Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import { API, graphqlOperation } from "aws-amplify";
import Moment from "moment-timezone";
import { default as React, useEffect, useReducer, useState } from "react";
import translate from "../../../i18n/translate";
import { ICalendarEvent, IFeedbackData, ILearnerSessions, IReschedulePopup, ISessionRating, IUpcomingData } from "../../../interfaces";
import { CancelSessionTMS } from "../../../queries";
import RollbarErrorTracking from "../../../utils/RollbarErrorTracking";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import Loader from "../../shared/Loader/Loader";
import SessionRatingPopup from "../../shared/SessionRatingPopup/SessionRatingPopup";
import Toaster from "../../shared/Toaster/Toaster";
import "./MyScheduleSummaryBlock.scss";
import { useSelector, useDispatch } from "react-redux";
import allActions from "../../../redux/actions";
import { ILocationState } from "../../../interfaces";
import { useHistory, useLocation } from "react-router-dom";
import ModalPopup from "../../shared/ModalPopup/ModalPopup";
import VideoPlayer from "../../shared/VideoPlayer/VideoPlayer";

let rescheduleWindow: any;
let roomWindow: any;


const LatestUpcomingBlock = (props: any) => {
  const [calPopup, setCalPopup] = useState(false);
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  const location = useLocation<ILocationState>();  
  const [upcomingsession, setSessionId] = useState(0);
  const [openPopup, setPopupState] = useState(false);
  const [openCancel, setCancelPopUp] = useState(false);
  const [openVideo, setOpenVideo] = useState<boolean>(false);
  const [cancelProps, setCancelProps] = useState({} as ILearnerSessions);

  const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      border: '1px solid',
      padding: theme.spacing(1),
      backgroundColor: theme.palette.background.paper,
    },
  }),
);
const classes = useStyles();
  const openRescheduleWindow = (sessionId: number) => {
    let w = 630;
    let h = 440; // default sizes
    if (window.screen) {
      w = window.screen.availWidth - 10;
      h = window.screen.availHeight - 70;
    }
    rescheduleWindow = window.open(
      `${process.env.REACT_APP_TMS_URL}` + "/v2/sessions/" + sessionId + "/reschedule",
      "Reschedule Session",
      "height=" +
      h +
      ",width=" +
      w +
      ",dependent=yes,location=no,menubar=no," +
      "resizable=yes,scrollbars=yes,status=no,toolbar=no"
    );
    rescheduleWindow.focus();
    checkWindowCloseTimer(rescheduleWindow);
  };
  const checkWindowCloseTimer = (learnerWindow: any) => {

    const checkTimer: any = setInterval(() => {
      if (learnerWindow.closed) {
        clearInterval(checkTimer);
        const courseId: number = Number(sessionStorage.getItem("courseId")) || 0;
        if (!!!allInfo.createSessionService.isLoading) {
          dispatch(allActions.createSessionServiceAction.createSessionService(courseId));
        }
        if (!!!allInfo.tmsLearnerSessions.isLoading) {
          dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId));
        }
      }
    }, 1000);
  };
  const handleClick = (sessionId: number) => {
    if (sessionStorage.getItem("RescheduleChkBox") === "False") {
      setPopupState(true);
      setSessionId(sessionId);
    } else {
      setPopupState(false);
      openRescheduleWindow(sessionId);
    }
  };
  const openJoinNowSession = (classRoomLink: any) => {
    let playVideo = false;
    let w = 7680;
    let h = 4320; // default sizes
    if (window.screen) {
      w = window.screen.availWidth - 10;
      h = window.screen.availHeight - 70;
    }
    const roomWindow = window.open(
      classRoomLink,
      "Classroom Window",
      "height=" +
      h +
      ",width=" +
      w +
      ",dependent=yes,location=no,menubar=no," +
      "resizable=yes,scrollbars=yes,status=no,toolbar=no"
    );
    if (roomWindow != null) {
      roomWindow.focus();
    }
  };
  const handleCancel = (cancelData: ILearnerSessions) => {
    setCancelPopUp(true);
    setCancelProps(cancelData);
  };
  const handleJoinNow = () => {
    if (!!sessionStorage.getItem("isDemoUser")) {
      setOpenVideo(true);   
    } else {
      if (props.isJoinNowEnabled) {
        openJoinNowSession(props.classRoomLink);
      }
    }
  };
  const handleClose = () => {
    setCalPopup(false);
  };
  return (
    <React.Fragment>
      {Object.keys(props.RecentData).length > 0 && (
        <React.Fragment>
          <div className="sub-header">
          <span className="recent-session-font">{translate("myschedule_next_session")}</span>
          <div>
            {/* HIDING ADD TO CALENDAR BUTTON, WILL UNCOMMENT LATER */}
              {/* <Button
                  className={
                    (!!!props.calendarEvents.length && "button primary joinnow-button-inactive") || "button primary large"}
                  type="button" variant="contained" color="primary"  aria-describedby="button-export-events" onClick={() => setCalPopup(true)}>
                 <img className="add-to-calendar-image" src={"../../../images/schedule-calendar/event-calendar.svg"}></img> <Typography className="add-to-calendar-button">{"Add to calendar"}</Typography>
                </Button> */}
                </div>
              </div>
          <div className="schedule-container">
            <div className="next-schedule-details">
              <div>
                <span>{translate("myschedule_sessionDetails_teacher_name")}</span>
                <span>{props.RecentData.CoachName}</span>
              </div>
              <div>
                <span>{translate("myschedule_sessionDetails_date")} / {translate("myschedule_sessionDetails_time")}</span>
                <span>
                  {props.RecentData.Session_GetstartDate} / {props.RecentData.StartTime}
                </span>
              </div>
              <div>
                <Button id="joinNowEnableDisable"
                  className={
                    (!props.isJoinNowEnabled && "button primary joinnow-button-inactive") || "button primary large"}
                    disabled = {!props.isJoinNowEnabled? true : false}
                  type="button" variant="contained" color="primary" onClick={() => handleJoinNow()}>
                  <span className="submit-text">{translate("myschedule_upcoming_joinNow")}</span>
                </Button>
                {openVideo && (
                  <ModalPopup
                    toggleOpen={openVideo}
                    setOpen={setOpenVideo}
                    classNameProps="video-card"
                    body={
                      <React.Fragment>
                        <VideoPlayer source={(location?.state?.productId === "20") ? "https://cdn.jwplayer.com/manifests/CODmYBc3.m3u8" : "https://cdn.jwplayer.com/manifests/qbYvLCyP.m3u8"} isplaying ={true} width={'93vw'} height={'95vh'} controls={true} fullscreen={true}></VideoPlayer>
                        <div className="closeVideo" onClick={() => setOpenVideo(false)}>x</div>
                      </React.Fragment>
                    }
                  />
                )}
              </div>
              <div>
                {props.RecentData.IconType === "Cancel" && props.isCancelVisible && (
                  <span className="Reschedule_text_button" onClick={() => handleCancel(props.RecentData)}>
                    {translate("profile_cancelLabel")}
                  </span>
                )}
                {props.RecentData.IconType === "Reschedule" && (
                  <span className="Reschedule_text_button" onClick={() => handleClick(props.RecentData.SessionId)}>
                    {translate("myschedule_reschedule_button")}
                  </span>
                )}
                {props.RecentData.IconType === "N/A" && "N/A"}
              </div>
            </div>
          </div>
          <div>
      <Dialog
        open={calPopup}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className ="scheduler-popup"
       
      >
      <DialogTitle className="calendar-title">Add to calendar</DialogTitle>
      <DialogContent>
      <DialogContentText className="calendar-dialog-text">
        <ul>
          <li>Click on the  <img src={"../../../images/schedule-calendar/download-icon.svg"} className="calendar-download-icon"></img> download button to get your Learnship schedule. You can then add it to your personal calendar. </li>
          <br></br>
          <li>If you have previously added a Learnship schedule to your calendar, please make sure to delete the existing one first.</li>
          <br></br>
          <li>Learn more about how to add the Learnship schedule to your personal calendar  <Link href="#">here</Link></li>
        </ul>
        </DialogContentText>
      <div className="calendar-download-button"> 
      <span className="calendar-button-align">
      <Button
      
                  className={
                    (!!!props.calendarEvents.length && "button primary joinnow-button-inactive calendar-button-align") || "button primary large calendar-button-align"}
                  type="button" variant="contained" color="primary"  aria-describedby="button-export-events" onClick={() => props.handleCalendarClick()}>
                  <Typography className="calendar-dialog-text"> <img src={"../../../images/schedule-calendar/download-icon.svg"} className="calendar-download-icon"></img> {"   Download"}</Typography>
                </Button> 
       </span>
       </div>
      </DialogContent>
  
      </Dialog>
      </div>
        </React.Fragment>
      )}
      {openPopup && (
        <ReschedulePopup
          currentSessionId={upcomingsession}
          openPopup={openPopup}
          setPopupState={setPopupState}
          handleDispatch={props.handleDispatch}
        ></ReschedulePopup>
      )}
      {openCancel && (
        <CancelPopup cancelProps={cancelProps} setCancelPopUp={setCancelPopUp} openCancel={openCancel} setJoinNow={props.setJoinNow} isLatestCancel={true}></CancelPopup>
      )}
    </React.Fragment>
  );
};
const RescheduleSecondPage = () => {
  const [currentProductName, setCurrentProductName] = useState("");
  const allInfo = useSelector((state: any) => state);
  useEffect(() => {
    const currentData : any =  allInfo.createSessionService.data != null ? JSON.parse(JSON.stringify(allInfo.createSessionService.data.createSessionService)) : null;
    if (currentData != null && currentData.length > 0) {
 let incomingName = JSON.parse(process.env.REACT_APP_BLENDED_PRODUCTS_FILTER || "").map((value: string) => value.toLowerCase()) || [{}];
 let replaceName = JSON.parse(process.env.REACT_APP_BLENDED_PRODUCT_NAME || "") || [{}];
 var index = incomingName.findIndex((product: string | any[]) => currentData.name.toLowerCase().includes(product));
 if(index!==-1)
 setCurrentProductName(replaceName[index]);

}
     
}, [allInfo.createSessionService]);
  return (
    <div id="intercept-second-page">
      <div className="jss1591 jss1580">
        <div>
          <div className="jss1592">
            <div>
              <span className="jss1593">
                <span className="jss1594">
                  <svg className="jss90" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"></path>
                  </svg>
                </span>
                <span className="jss1597">
                  <span className="jss1595">
                    <span>{translate("myschedule_reschedule_next_instr1")}</span>
                  </span>
                </span>
              </span>
              <div className="jss1596">
                <span>{translate("myschedule_reschedule_next_instr2")}</span>
              </div>
            </div>
            <div>
              <span className="jss1593">
                <span className="jss1594">
                  <svg className="jss90" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                    <path fill="none" d="M0 0h24v24H0V0z"></path>
                    <g>
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.51.88 4.93 1.78C15.57 19.36 13.86 20 12 20s-3.57-.64-4.93-1.72zm11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83z"></path>
                      <path d="M12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z"></path>
                    </g>
                  </svg>
                </span>
                <span className="jss1597">
                  <span className="jss1595">
                    <span>{translate("myschedule_reschedule_next_instr3")}</span>
                  </span>
                </span>
              </span>
              <div className="jss1696">
                <span>{translate("myschedule_reschedule_next_instr4a")} </span>
                <a href={`${process.env.REACT_APP_GE_SUPPORT_URL}/En-en/contact_support`} target="_blank">
                  <span>{translate("myschedule_reschedule_next_instr4b")}</span>
                </a>
                <span>{translate("myschedule_reschedule_next_instr4c", { productname:currentProductName })}{" "}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="jss1585">
          <div>
            <span>{translate("myschedule_rechedule_next_info")} </span>
            <a
              href={`${process.env.REACT_APP_GE_SUPPORT_URL}/En-en/getting_started/globalenglishcoach`}
              target="_blank"
              className="jss1587"
            >
              <span>{translate("myschedule_rechedule_next_faq")}</span>
            </a>
          </div>
          <div>
            <label className="jss1674">
              <input
                type="checkbox"
                onChange={() => {
                  sessionStorage.getItem("RescheduleChkBox") === "False"
                    ? sessionStorage.setItem("RescheduleChkBox", "True")
                    : sessionStorage.setItem("RescheduleChkBox", "False");
                }}
              />
              <span className="checkmark"></span>
              <span className="jss177 jss186 jss1677 jss1586">
                <span>{translate("myschedule_rechedule_next_noShow")}</span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};
const RescheduleFirstPage = () => {
  return (
    <React.Fragment>
      <div id="intercept-first-page">
        <div className="jss1591 jss1580">
          <div className="jss1582">
            <div className="jss1581">
              <span>{translate("myschedule_reschedule_InstrBegin")}</span>
            </div>
            <div className="jss930">
              <div className="jss931 jss992">
                <div className="jss1592">
                  <div>
                    <span className="jss1593">
                      <span className="jss1594">
                        <svg className="jss1598" focusable="false" viewBox="0 0 24 24">
                          <circle cx="12" cy="12" r="11" fill="none" stroke="#19B29C" stroke-width="2"></circle>
                          <text className="jss1599" x="12" y="16" text-anchor="middle" stroke="#19B29C">
                            1
                          </text>
                        </svg>
                      </span>
                      <span className="jss1597">
                        <span className="jss1595">
                          <span>{translate("myschedule_reschedule_instr1a")}</span>
                        </span>
                      </span>
                    </span>
                    <div className="jss1596">
                      <span>{translate("myschedule_reschedule_instr1b")}</span>
                    </div>
                  </div>
                  <div>
                    <span className="jss1593">
                      <span className="jss1594">
                        <svg className="jss1598" focusable="false" viewBox="0 0 24 24">
                          <circle cx="12" cy="12" r="11" fill="none" stroke="#19B29C" stroke-width="2"></circle>
                          <text className="jss1599" x="12" y="16" text-anchor="middle" stroke="#19B29C">
                            2
                          </text>
                        </svg>
                      </span>
                      <span className="jss1597">
                        <span className="jss1595">
                          <span>{translate("myschedule_reschedule_instr2")}</span>
                        </span>
                      </span>
                    </span>
                    <div className="jss1596">
                      <span>{translate("myschedule_reschedule_instr3")}</span>
                    </div>
                  </div>
                  <div>
                    <span className="jss1593">
                      <span className="jss1594">
                        <svg className="jss1598" focusable="false" viewBox="0 0 24 24">
                          <circle cx="12" cy="12" r="11" fill="none" stroke="#19B29C" stroke-width="2"></circle>
                          <text className="jss1599" x="12" y="16" text-anchor="middle" stroke="#19B29C">
                            3
                          </text>
                        </svg>
                      </span>
                      <span className="jss1597">
                        <span className="jss1595">
                          <span>{translate("myschedule_reschedule_instr4")}</span>
                        </span>
                      </span>
                    </span>
                    <div className="jss1697">
                      <span>{translate("myschedule_reschedule_instr5")}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="jss931 jss992">
                <div className="jss1583">
                  <img src="../../../images/Schedule/reschedule-session.png" alt="tms_session_reschedule" className="jss1584" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const AllSessionBlock = (props: any) => {
  const history = useHistory();
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  const [ratingPopup, setRatingPopup] = useState(false);
  const openRoomWindow = (classRoomLink: any) => {
    let w = 7680;
    let h = 4320; // default sizes
    if (window.screen) {
      w = window.screen.availWidth - 10;
      h = window.screen.availHeight - 70;
    }
    roomWindow = window.open(
      classRoomLink,
      "Classroom Window",
      "height=" +
      h +
      ",width=" +
      w +
      ",dependent=yes,location=no,menubar=no," +
      "resizable=yes,scrollbars=yes,status=no,toolbar=no"
    );
    roomWindow.focus();
  };

  const viewsessionreport = (SessionId: number) => {
    history.push(`/sessionreport/${SessionId}`);
  };
  const [upcomingsession, setSessionId] = useState(0);
  const [openPopup, setPopupState] = useState(false);
  const [openCancel, setCancelPopUp] = useState(false);
  const [cancelProps, setCancelProps] = useState({} as ILearnerSessions);
  const handleCancel = (cancelData: ILearnerSessions) => {
    setCancelPopUp(true);
    setCancelProps(cancelData);
  };
  const openRescheduleWindow = (sessionId: number) => {
    let w = 630;
    let h = 440; // default sizes
    if (window.screen) {
      w = window.screen.availWidth - 10;
      h = window.screen.availHeight - 70;
    }
    rescheduleWindow = window.open(
      `${process.env.REACT_APP_TMS_URL}` + "/v2/sessions/" + sessionId + "/reschedule",
      "Reschedule Session",
      "height=" +
      h +
      ",width=" +
      w +
      ",dependent=yes,location=no,menubar=no," +
      "resizable=yes,scrollbars=yes,status=no,toolbar=no"
    );
    rescheduleWindow.focus();
    checkWindowCloseTimer(rescheduleWindow);
  };
  const checkWindowCloseTimer = (learnerWindow: any) => {

    const checkTimer: any = setInterval(() => {
      if (learnerWindow.closed) {
        clearInterval(checkTimer);
        const courseId: number = Number(sessionStorage.getItem("courseId")) || 0;
        if (!!!allInfo.createSessionService.isLoading) {
          dispatch(allActions.createSessionServiceAction.createSessionService(courseId));
        }
        if (!!!allInfo.tmsLearnerSessions.isLoading) {
          dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId));
        }
      }
    }, 1000);
  };
  const handleClick = (sessionId: number) => {
    setPopupState(true);
    if (sessionStorage.getItem("RescheduleChkBox") === "False") {
      setSessionId(sessionId);
    } else {
      setPopupState(false);
      openRescheduleWindow(sessionId);
    }
  };

  return (
    <div className="Table-Container">
      <div className="sessions-information-container">
        {props.UpcomingData != null &&
          Object.keys(props.UpcomingData).length > 0 &&
          Object.keys(props.UpcomingData).map((key: any) => {
            return (
              <div className="session-details-wrapper">
                <div className="details-conatiner first-column">
                  <span>{translate("myschedule_sessionDetails_sessions")}</span>
                  <div>{props.UpcomingData[key].SessionNumber}</div>
                </div>

                <div className="details-conatiner second-column">
                  <span>{translate("myschedule_sessionDetails_teacher_name")}</span>
                  <div>{props.UpcomingData[key].CoachName}</div>
                </div>

                <div className="details-conatiner third-column">
                  <span>{translate("myschedule_sessionDetails_date")}/ {translate("myschedule_sessionDetails_time")} / {translate("myschedule_sessionDetails_durationText")}</span>
                  <div>{props.UpcomingData[key].Session_GetstartDate} / {props.UpcomingData[key].StartTime} / {props.UpcomingData[key].DurationMins} {translate("myschedule_sessionDetails_min")}</div>
                </div>

                <div className="details-conatiner fourth-column">
                  <span>{translate("SessionRating_status")}</span>
                  <div>
                    <span>
                      {props.UpcomingData[key].IconType === "Cancel" && (
                        <span className="Reschedule_text_button" onClick={() => handleCancel(props.UpcomingData[key])}>
                          {translate("profile_cancelLabel")}
                        </span>
                      )}
                      {props.UpcomingData[key].IconType === "Reschedule" && (
                        <span
                          className="Reschedule_text_button"
                          onClick={() => handleClick(props.UpcomingData[key].SessionId)}
                        >
                          {translate("myschedule_reschedule_button")}
                        </span>
                      )}
                      {(props.UpcomingData[key].IconType === "finished" ||
                        props.UpcomingData[key].IconType === "canceled" ||
                        props.UpcomingData[key].IconType === "lost") && (
                          <input
                            className={"button primary " + props.UpcomingData[key].IconType}
                            type="button"
                            value={props.UpcomingData[key].IconType.charAt(0).toUpperCase() + props.UpcomingData[key].IconType.slice(1)}
                          />
                        )}
                    </span>
                  </div>
                </div>
                { !!!sessionStorage.getItem("isDemoUser") &&
                  <div className="details-conatiner fifth-column">
                    <span>{translate("SessionReport_sessionReview")}</span>
                    <div>
                      {props.UpcomingData[key].IconType === "finished" ? (
                        <Link
                          className="RatingLinks"
                          onClick={() => openRoomWindow(props.UpcomingData[key].SessionLocation)}
                        >
                          {translate("SessionReport_sessionReview")}
                        </Link>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>
                }

                <div className="details-conatiner sixth-column">
                  <span>{translate("SessionReport_sessionReport")}</span>
                  <div>
                    {(props.UpcomingData[key].IconType === "finished" && (
                      <Link
                        className="RatingLinks"
                        onClick={() => {
                          viewsessionreport(props.UpcomingData[key].SessionId);
                        }}
                      >
                        {translate("myschedule_homepage_view")}
                      </Link>
                    )) ||
                      (props.UpcomingData[key].IconType !== "finished" && <div>N/A</div>)}
                  </div>
                </div>
              </div>
            )
          })}
        {props.records === "All sessions" && Object.keys(props.UpcomingData).length === 0 && (
          <div className="nosessions-container">
            <span>
              {translate("myschedule_no_sessions")}
            </span>
          </div>
        )}
        {props.records === "Upcoming sessions" && Object.keys(props.UpcomingData).length === 0 && (
          <div className="nosessions-container">
            <span>
              {translate("myschedule_no_upcoming_sessions")}
            </span>
          </div>
        )}
        {props.records === "Past sessions" && Object.keys(props.UpcomingData).length === 0 && (
          <div className="nosessions-container">
            <span>
              {translate("myschedule_no_past_sessions")}
            </span>
          </div>
        )}
      </div>

      {openCancel && (
        <CancelPopup cancelProps={cancelProps} setCancelPopUp={setCancelPopUp} openCancel={openCancel} setJoinNow={props.setJoinNow} isLatestCancel={false}></CancelPopup>
      )}
      {openPopup && (
        <ReschedulePopup
          currentSessionId={upcomingsession}
          openPopup={openPopup}
          setPopupState={setPopupState}
          handleDispatch={props.handleDispatch}
        ></ReschedulePopup>
      )}
    </div>
  );

};

const ReschedulePopup: React.FC<IReschedulePopup> = ({ currentSessionId, openPopup, setPopupState, handleDispatch }) => {
  const [open, setOpen] = useState(true);
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  const [NextButton, setNextButton] = useState("Next");
  const [skipButton, setSkipButton] = useState("Skip");
  const [sessionId, setSessionId] = useState(currentSessionId);
  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });

  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  }

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", !!open);
  };
  const handleClose = () => {
    setOpen(false);
    setPopupState(false);
  };

  const nextOnClick = () => {
    if (NextButton === "Next") {
      setNextButton("Done");
      setSkipButton("<");
    } else if (NextButton === "Done") {
      setOpen(false);
      setPopupState(false);
      openRescheduleWindow(sessionId);
    }
  };
  const openRescheduleWindow = (sessionId: number) => {
    let w = 630;
    let h = 440; // default sizes
    if (window.screen) {
      w = window.screen.availWidth - 10;
      h = window.screen.availHeight - 70;
    }
    rescheduleWindow = window.open(
      `${process.env.REACT_APP_TMS_URL}` + "/v2/sessions/" + sessionId + "/reschedule",
      "Reschedule Session",
      "height=" +
      h +
      ",width=" +
      w +
      ",dependent=yes,location=no,menubar=no," +
      "resizable=yes,scrollbars=yes,status=no,toolbar=no"
    );
    rescheduleWindow.focus();
    checkWindowCloseTimer(rescheduleWindow);
  };
  const checkWindowCloseTimer = (learnerWindow: any) => {

    const checkTimer: any = setInterval(() => {
      if (learnerWindow.closed) {
        clearInterval(checkTimer);
        const courseId: number = Number(sessionStorage.getItem("courseId")) || 0;
        if (!!!allInfo.createSessionService.isLoading) {
          dispatch(allActions.createSessionServiceAction.createSessionService(courseId));
        }
        if (!!!allInfo.tmsLearnerSessions.isLoading) {
          dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId));
        }
      }
    }, 1000);
  };
  const skipButtonClick = () => {
    if (skipButton === "Skip") {
      setOpen(false);
      setPopupState(false);
      openRescheduleWindow(sessionId);
    } else {
      setNextButton("Next");
      setSkipButton("Skip");
    }
  };

  return (
    <Dialog
      open={openPopup}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="intercept-page-dialog"
    >
      <DialogTitle className="jss1581" id="alert-dialog-title">
        {translate("myschedule_reschedule_Title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {NextButton === "Next" && <RescheduleFirstPage></RescheduleFirstPage>}
          {NextButton === "Done" && <RescheduleSecondPage></RescheduleSecondPage>}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div className="jss1600">
          <Button
            size="medium"
            onClick={() => skipButtonClick()}
            id="skip-intercept-page"
            tabIndex={0}
            className="skip-button"
          >
            <span className={skipButton === "Skip" ? "jss1603" : "jss1631"}>
              <span>{skipButton === "Skip" ? translate("myschedule_rechedule_skipButton") : skipButton}</span>
            </span>
            <span className="jss1631"></span>
          </Button>
          <Button
            color="primary" variant="contained" size="medium"
            onClick={() => nextOnClick()}
            id="intercept-next-button"
            tabIndex={0}
            className="next-intercept-page-button"
          >
            <span className="jss1639">
              <span>
                {NextButton === "Done"
                  ? translate("myschedule_rechedule_next_done")
                  : translate("button_next")}
              </span>
            </span>
            <span className="jss1667"></span>
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  )
};

const CancelPopup = (props: any) => {
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(props.openCancel);
  const [status, setstatus] = useState(0);
  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });

  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  }

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", !!open);
  };
  const handleClose = () => {
    setOpen(false);
    props.setCancelPopUp(false);
  };

  const CancelOnCLick = (setJoinNow: any, isLatestCancel: boolean) => {

    const learnerToken = sessionStorage.getItem("jwToken");
    const sessionId: string = props.cancelProps.SessionId;
    const cancelSession = API.graphql(graphqlOperation(CancelSessionTMS, { learnerToken, sessionId })) as Promise<any>;
    cancelSession.then((data: any) => {
      setOpen(false);
      props.setCancelPopUp(false);

      if (!!!allInfo.createSessionService.isLoading) {
        dispatch(allActions.createSessionServiceAction.createSessionService(Number(sessionStorage.getItem("courseId"))));
      }
      if (!!!allInfo.tmsLearnerSessions.isLoading) {
        dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId));
      }
      if (isLatestCancel) {
        setJoinNow(false);
      }
      toasterHandle(true, "success", "message_welcomeSubmitted");
    },
      (error) => (err: Error) => {
        toasterHandle(true, "error", "message_errorDefault");
        setstatus(sessionStorage.getItem("isScheduleRequired") !== "true" ? 401 : 1);
        RollbarErrorTracking.logErrorInRollbar(err.message, "error");
      });
  };

  return status === 0 ? (
    <Dialog
      className="cancel-session-dialog"
      open={props.openCancel}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle className="jss1581" id="alert-dialog-title">
        {translate("myschedule_cancel_question")}
        <CloseIcon className="closeButton" onClick={handleClose}></CloseIcon>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix"></div>
          <div id="cancel-session-popup" className="ui-dialog-content ui-widget-content">
            <div id="cancelSessionData">
              <div className="cancel-schedule-details">
                <span>{props.cancelProps.CoachName}</span>
                <span>{props.cancelProps.Session_GetstartDate}</span>
                <span>{props.cancelProps.StartTime}</span>
                <span>{props.cancelProps.DurationMins} {translate("myschedule_sessionDuraion_minutes")}</span>


              </div>
            </div>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div className="session-cancel-buttons">
          <Button
            size="medium"
            className="button session cancel"
            onClick={() => handleClose()}
            id="skip-page"
            tabIndex={0}
          >
            <span>
              <span>{translate("myschedule_cancel_no")}</span>
            </span>
            <span className="jss1631"></span>
          </Button>
          <Button
            color="primary" variant="contained" size="medium"
            onClick={() => CancelOnCLick(props.setJoinNow, props.isLatestCancel)}
            id="intercept-next-button"
            tabIndex={0}
            className="next-intercept-page-button"
          >
            <span className="jss1639">
              <span>{translate("myschedule_cancel_button")}</span>
            </span>
            <span className="jss1667"></span>
          </Button>
        </div>
      </DialogActions>

    </Dialog>

  ) : (
    <Dialog
      className="cancel-session-dialog"
      open={props.openCancel}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <ErrorPage status={status}></ErrorPage>
      <Toaster
        open={toastOptions.toastOpen}
        severity={toastOptions.toastSeverity}
        toasterClosed={toasterHandle}
        messageKey={toastOptions.toastMessageKey}
      />

    </Dialog>
  );
};
const PastAndUpcomingSessions = () => {
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  let response: any;
  // document.title = "Halo - Schedule"
  let [status, setstatus] = useState(0);

  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });

  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  }
  const handleCalendarClick = () => {
    const cal = require('ics');
    const modifiedEvents = calendarEvents.map(({uid, ...keepAttrs}) => keepAttrs);
    if (typeof (cal) !== "undefined") {
      const {value} = cal.createEvents([...modifiedEvents]);
      saveIcs(value, "LearnshipCalendar", "ics");
    }
  };
  function saveIcs(calendar: any, filename : string, ext : String) {
    let blob;
    const updatedCalendar : string = [calendar.slice(0, 15),"\nX-WR-CALNAME:Learnship", calendar.slice(15)].join('');
    if (navigator.userAgent.indexOf('MSIE 10') === -1) { // chrome or firefox
      blob = new Blob([updatedCalendar]);
    } else { // ie
      const bb = new MSBlobBuilder();
      bb.append(updatedCalendar);
      blob = bb.getBlob('text/x-vCalendar;charset=' + document.characterSet);
    }
    const FileSaver = require('file-saver');
    FileSaver.saveAs(blob, filename + "." + ext);
    return updatedCalendar;
  }
  const handleDispatch = () => {
    const courseId: number = Number(sessionStorage.getItem("courseId")) || 0;
    if (!!!allInfo.createSessionService.isLoading) {
      dispatch(allActions.createSessionServiceAction.createSessionService(courseId));
    }
    if (allInfo.tmsLearnerSessions.isLoading) {
      dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId));
    }
  }

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", !!open);
  };
  let session_starttimeUTC: any;
  let session_endtimeUTC: any;
  let session_GetstartDate: any;
  let durationMins: number;
  let coachname: any;
  let sessionId: any;
  let startTime: any;
  let session_GetEndDate: any;
  let rescheduleDiffHours: any;
  let rescheduleSeatPoolHours: any;
  let rescheduleLimit: any;
  let sessionRescheduleCalculation: any;
  const [cancelledSessionCount, setcancelledSessionCount] = useState(0);
  let UpcomingArray: IUpcomingData[] = {} as IUpcomingData[];
  let UpcomingCounter: number = 0;
  let ClassCounter: number = 0;
  let allowReschedule: boolean = false;
  let allowCancellation: boolean = false;
  const upcomingSessionsData: ILearnerSessions[] = {} as ILearnerSessions[];
  const pastSessionsData: ILearnerSessions[] = {} as ILearnerSessions[];
  const FinishedSessionsData: ILearnerSessions[] = {} as ILearnerSessions[];
  const RecentUpcomingData: ILearnerSessions = {} as ILearnerSessions;
  const [RecentData, SetRecentData] = useState({} as ILearnerSessions);
  const [UpcomingData, SetUpcomingData] = useState(upcomingSessionsData as ILearnerSessions[]);
  const [PastData, SetPastData] = useState(upcomingSessionsData as ILearnerSessions[]);
  const [AllSessionData, SetAllSessionData] = useState({} as ILearnerSessions[]);
  let PastCounter: number = 0;
  let finishedCounter: number = 0;
  let momentDate : any;
  let momentEndDate : any;
  const [isJoinNowEnabled, setJoinNow] = useState(false);
  const [isCancelVisible, setcancelButton] = useState(false);
  const [currentSessionLink, setCurrentSessionLink] = useState("");
  const [records, setRecords] = React.useState("All sessions");
  const [sessionRatingProps, setSessionRating] = useState({} as ISessionRating);
  const [ratingPopup, setRatingPopup] = useState(false);
  const [duration, setDuration] = useState(0);
  const [comMode, setComMode] = useState("");
  const [loaderFlag, setLoaderFlag] = useState(true);
  const [calendarEvents, setCalenderEvents] =useState<ICalendarEvent[]>([]);
  let addCalendarEvents = [] as ICalendarEvent[];

  let sessionNumber: number = 0;
  useEffect(() => {
    sessionStorage.setItem("RescheduleChkBox", "False");
  }, []);


  useEffect(() => {
    if (
      !!!allInfo.getLearnerFeedback.isLoading &&
      !!!allInfo.tmsLearnerSessions.isLoading
    ) {
      setLoaderFlag(false);
    } else {
      setLoaderFlag(true);
    }
    if (!!allInfo.getLearnerFeedback.data && !!allInfo.tmsLearnerSessions.data) {
      getSessionDetails();
    }
  }, [allInfo.tmsLearnerSessions, allInfo.learnerJWToken, allInfo.getLearnerFeedback]);

  const getSessionDetails = () => {
    getLatestSessionDetails(allInfo.getLearnerFeedback.data);
  };
  const joinNowCheck = (startTime: any, classRoomLink: any) => {
    let joinNowDiffHours = (startTime - Moment().unix()) / 60;
    if (joinNowDiffHours <= 10 || !!sessionStorage.getItem("isDemoUser")) {
      setJoinNow(true);
      if (!!sessionStorage.getItem("isDemoUser")) {
        setCurrentSessionLink("../../../videos/virtual-classroom.mp4");
      }
      else
        setCurrentSessionLink(classRoomLink);
    } else {
      setJoinNow(false);
    }
    if (joinNowDiffHours <= 0) {
      setcancelButton(false);
    }
    else {
      setcancelButton(true);
    }
  };

  const handeRecords = (event: React.ChangeEvent<{ value: unknown }>) => {
    setRecords(event.target.value as string);
  };
  const getLatestSessionDetails = (feebackDetails: any) => {
    const canceledSessionCountCheck = (sessions: any) => {
      for (let i = 0; i < sessions.length; i++) {
        if (sessions[i].status === "canceled" || sessions[i].status === "lost") {
          setcancelledSessionCount(cancelledSessionCount + 1);
        }
      }
      return cancelledSessionCount;
    };
    response = allInfo.tmsLearnerSessions.data.getTMSLearnerSessions
      .slice()
      .sort((a: any, b: any) => b.startTime - a.startTime)
      .reverse();
    canceledSessionCountCheck(allInfo.tmsLearnerSessions.data);

    //To set duration for a single session
    let singleDuration: number = parseInt(process.env.REACT_APP_MAX_SESSION_HOURS || "0");
    setDuration(singleDuration);
    for (let i = 0; i < response.length; i++) {
      let sessionDuration: number = (parseInt(response[i].endTime) - parseInt(response[i].startTime)) / 60;
      if (sessionDuration < singleDuration && response[i].course === parseInt(window.location.href.split("/")[4])) {
        singleDuration = sessionDuration;

      }
      setDuration(singleDuration);
    }

    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < response.length; i++) {
      // tslint:disable-next-line: prefer-for-of
      for (let j = 0; j < response[i].students.length; j++) {
        if (response[i].course === parseInt(window.location.href.split("/")[4])) {
          session_starttimeUTC = Moment.unix(parseInt(response[i].startTime)).format("hh:mm A");
          session_endtimeUTC = Moment.unix(parseInt(response[i].endTime)).format("hh:mm A");
          session_GetstartDate = Moment.unix(parseInt(response[i].startTime)).format("DD MMMM YYYY");
          session_GetEndDate = Moment.unix(parseInt(response[i].endTime)).format("DD MMMM YYYY");
          durationMins = (parseInt(response[i].endTime) - parseInt(response[i].startTime)) / 60;

          if (response[0].sessionCalendarType === "onsite") {
            setComMode(response[i].sessionLocation);
          } else {
            setComMode("Virtual classroom");
          }
          if (response[i].teacher != null) {
            coachname = response[i].teacher.name.replace(/,/g, "");
            sessionId = response[i].id;
          } else {
            sessionId = response[i].id;
            coachname = "";
          }
          momentDate = Moment(Moment.unix(parseInt(response[i].startTime)));
          momentEndDate= Moment(Moment.unix(parseInt(response[i].endTime)));
          startTime =
            session_starttimeUTC +
            " " +
              momentDate
              .tz(Moment.tz.guess())
              .format("z");
          if (response[i].status === "inProgress" || response[i].status === "upcoming") {
            let CalendarEvent : ICalendarEvent = {} as ICalendarEvent;
            let alarms = [];
            alarms.push({
              action: 'display',
              trigger: {hours:0,minutes:15,before:true},
            })
            CalendarEvent.alarms=alarms;
             CalendarEvent.start =[parseInt(momentDate.format("YYYY")),parseInt(momentDate.format("MM")), parseInt(momentDate.format("DD")), parseInt(momentDate.format("HH")), parseInt(momentDate.format("mm"))];
             momentDate= Moment(Moment.unix(parseInt(response[i].endTime)));
             CalendarEvent.end =[parseInt(momentEndDate.format("YYYY")),parseInt(momentEndDate.format("MM")), parseInt(momentEndDate.format("DD")), parseInt(momentEndDate.format("HH")), parseInt(momentEndDate.format("mm"))];
             CalendarEvent.title = "Session with teacher " + coachname;
             CalendarEvent.uid =String(sessionId);
             if (addCalendarEvents.length<=0 || addCalendarEvents.filter(unique=> unique.uid===sessionId).length<=0) 
             addCalendarEvents.push(CalendarEvent);
            sessionNumber = sessionNumber + 1;
            rescheduleDiffHours = (parseInt(response[i].startTime) - Moment().unix()) / 60;
            rescheduleSeatPoolHours = Number(process.env.REACT_APP_RESCHEDULING_NOTICE_HOUR) * 60;
            rescheduleLimit = Number(process.env.REACT_APP_RESCHEDULING_LIMIT);
            sessionRescheduleCalculation = Math.ceil((rescheduleLimit / 100) * response.length);
            if (rescheduleDiffHours > rescheduleSeatPoolHours) {
              allowReschedule = true;
            } else if (cancelledSessionCount < sessionRescheduleCalculation) {
              allowCancellation = true;
            } else {
              allowReschedule = false;
              allowCancellation = false;
            }

            UpcomingArray[ClassCounter] = {} as IUpcomingData;
            if (response[i].status === "inProgress") {
              if (
                parseInt(response[i].startTime) <= Moment().unix() &&
                parseInt(response[i].endTime) >= Moment().unix()
              ) {
                UpcomingArray[ClassCounter].upcomingTimeData = parseInt(response[i].startTime);
                UpcomingArray[ClassCounter].upcomingClassRoomLink = response[i].students[j].classroomLink;
                ClassCounter = ClassCounter + 1;
              }
            } else {
              if (parseInt(response[i].endTime) >= Moment().unix()) {
                UpcomingArray[ClassCounter] = {} as IUpcomingData;
                UpcomingArray[ClassCounter].upcomingTimeData = parseInt(response[i].startTime);
                UpcomingArray[ClassCounter].upcomingClassRoomLink = response[i].students[j].classroomLink;
                ClassCounter = ClassCounter + 1;
              }
            }
            if ((UpcomingArray[0].upcomingTimeData >= parseInt(response[i].startTime) && UpcomingArray[0].upcomingTimeData <= response[i].endTime) || !!sessionStorage.getItem("isDemoUser")) {
              RecentUpcomingData.SessionId = sessionId;
              RecentUpcomingData.CoachName = coachname;
              RecentUpcomingData.startTimeUnix = parseInt(response[i].startTime);
              RecentUpcomingData.Session_GetstartDate = session_GetstartDate;
              RecentUpcomingData.StartTime = startTime;
              RecentUpcomingData.DurationMins = durationMins.toString();
              RecentUpcomingData.IconType =
                !allowReschedule && !allowCancellation ? "N/A" : allowReschedule ? "Reschedule" : "Cancel";
              for (let sessionNum = 1; sessionNum < durationMins / singleDuration; sessionNum++) {
                sessionNumber = sessionNumber + 1;
                RecentUpcomingData.SessionNumber = RecentUpcomingData.SessionNumber + " & " + sessionNumber;
              }
              RecentUpcomingData.classroomLink = response[i].students[j].classroomLink;
            } else {
              if (response[i].status === "upcoming" || response[i].status === "inProgress") {
                upcomingSessionsData[UpcomingCounter] = {} as ILearnerSessions;
                upcomingSessionsData[0].FeedbackData = {} as IFeedbackData[];
                upcomingSessionsData[0].FeedbackData = feebackDetails;
                upcomingSessionsData[UpcomingCounter].CoachName = coachname;
                upcomingSessionsData[UpcomingCounter].SessionId = sessionId;
                upcomingSessionsData[UpcomingCounter].Session_GetstartDate = session_GetstartDate;
                upcomingSessionsData[UpcomingCounter].StartTime = startTime;
                upcomingSessionsData[UpcomingCounter].DurationMins = durationMins.toString();
                upcomingSessionsData[UpcomingCounter].SessionNumber = String(sessionNumber);
                upcomingSessionsData[UpcomingCounter].startTimeUnix = parseInt(response[i].startTime);
                for (let sessionNum = 1; sessionNum < durationMins / singleDuration; sessionNum++) {
                  sessionNumber = sessionNumber + 1;
                  upcomingSessionsData[UpcomingCounter].SessionNumber = upcomingSessionsData[UpcomingCounter].SessionNumber + " & " + sessionNumber;
                }
                upcomingSessionsData[UpcomingCounter].IconType =
                  !allowReschedule && !allowCancellation ? "N/A" : allowReschedule ? "Reschedule" : "Cancel";
                UpcomingCounter = UpcomingCounter + 1;
              }
            }
          } else if (
            response[i].status === "finished" ||
            response[i].status === "lost" ||
            response[i].status === "canceled"
          ) {
            if(calendarEvents.filter(events=> events.uid=== String(sessionId)).length>0)
            {
              addCalendarEvents = addCalendarEvents.filter(events=> events.uid!==String(sessionId));
            }
            pastSessionsData[PastCounter] = {} as ILearnerSessions;
            pastSessionsData[0].FeedbackData = {} as IFeedbackData[];
            if (response[i].status === "finished" || response[i].status === "lost") {
              sessionNumber = sessionNumber + 1;
              pastSessionsData[PastCounter].SessionNumber = String(sessionNumber);
              for (let sessionNum = 1; sessionNum < durationMins / singleDuration; sessionNum++) {
                sessionNumber = sessionNumber + 1;
                pastSessionsData[PastCounter].SessionNumber = pastSessionsData[PastCounter].SessionNumber + " & " + sessionNumber;
              }
            }
            pastSessionsData[0].FeedbackData = feebackDetails;
            pastSessionsData[PastCounter].CoachName = coachname;
            pastSessionsData[PastCounter].SessionId = sessionId;
            pastSessionsData[PastCounter].Session_GetstartDate = session_GetstartDate;
            pastSessionsData[PastCounter].StartTime = startTime;
            pastSessionsData[PastCounter].startTimeUnix = parseInt(response[i].startTime);
            pastSessionsData[PastCounter].DurationMins = durationMins.toString();
            if (response[i].status === "finished") {
              pastSessionsData[PastCounter].IconType = "finished";
              FinishedSessionsData[finishedCounter] = {} as ILearnerSessions;
              FinishedSessionsData[0].FeedbackData = {} as IFeedbackData[];
              FinishedSessionsData[0].FeedbackData = feebackDetails;
              FinishedSessionsData[finishedCounter].IconType = "finished";
              FinishedSessionsData[finishedCounter].CoachName = coachname;
              FinishedSessionsData[finishedCounter].SessionId = sessionId;
              FinishedSessionsData[finishedCounter].Session_GetstartDate = session_GetstartDate;
              FinishedSessionsData[finishedCounter].StartTime = startTime;
              FinishedSessionsData[finishedCounter].DurationMins = durationMins.toString();
              FinishedSessionsData[finishedCounter].SessionNumber = String(sessionNumber);
              FinishedSessionsData[finishedCounter].startTimeUnix = parseInt(response[i].startTime);
              FinishedSessionsData[finishedCounter].SessionId = sessionId;
              finishedCounter = finishedCounter + 1;
              pastSessionsData[PastCounter].SessionLocation = response[i].students[j].classroomLink;
            } else if (response[i].status === "lost") {
              pastSessionsData[PastCounter].IconType = "lost";
            } else if (response[i].status === "canceled") {
              pastSessionsData[PastCounter].IconType = "canceled";
            }
            PastCounter = PastCounter + 1;
          }



        }
      }

    }
    setCalenderEvents(addCalendarEvents);
    SetRecentData(RecentUpcomingData);
    SetUpcomingData(upcomingSessionsData);
    SetPastData(pastSessionsData);
    if (PastCounter > 0 && finishedCounter > 0) {
      const feedbackParsed = JSON.parse(allInfo.getLearnerFeedback.data.getLearnerFeedback);
      for(let finished=1; finished<=finishedCounter; finished++)
      {
     
         if(feedbackParsed.filter((data: { session_id: any; })=>Number(data.session_id)===Number(FinishedSessionsData[finishedCounter - finished].SessionId)).length>0)
        {
          continue;
        }
        else
        {
          if (sessionStorage.getItem("RemindLater") !== "true") {
            const SessionDetails: ISessionRating = {} as ISessionRating;
            SessionDetails.IsReadOnly = false;
            SessionDetails.Content = false;
            SessionDetails.Technology = false;
            SessionDetails.Teacher = false;
            SessionDetails.SessionDate = FinishedSessionsData[finishedCounter - finished].Session_GetstartDate || "";
            SessionDetails.SessionDuration = FinishedSessionsData[finishedCounter - finished].DurationMins || "";
            SessionDetails.SessionTime = FinishedSessionsData[finishedCounter - finished].StartTime || "";
            SessionDetails.Status = FinishedSessionsData[finishedCounter - finished].IconType || "";
            SessionDetails.CoachName = FinishedSessionsData[finishedCounter - finished].CoachName || "";
            SessionDetails.SessionID = FinishedSessionsData[finishedCounter - finished].SessionId;
            setSessionRating(SessionDetails);
            setRatingPopup(true);
          }
          break;
        }
      }
    }
    const allData: ILearnerSessions[] = { ...pastSessionsData };
    for (let i = PastCounter, j = 0; i < PastCounter + UpcomingCounter && j <= UpcomingCounter; i++, j++) {
      allData[i] = upcomingSessionsData[j];
    }
    var sortedArray: ILearnerSessions[] = Object.values(allData).slice()
      .sort((a: any, b: any) => a.startTimeUnix - b.startTimeUnix);
    SetAllSessionData(sortedArray);
    setLoaderFlag(false);
  };
     
  useEffect(() => {
    const checkJoinNowButtonEnable = setInterval(() => {
      joinNowCheck(RecentData.startTimeUnix, RecentData.classroomLink);
    }, 1000);
    return () => clearInterval(checkJoinNowButtonEnable);
  }, [RecentData]);
  return typeof (status) === 'undefined' || status === null || status === 0 ? (
    <React.Fragment>
      <LatestUpcomingBlock
        RecentData={RecentData}
        isJoinNowEnabled={isJoinNowEnabled}
        classRoomLink={currentSessionLink}
        isCancelVisible={isCancelVisible}
        setJoinNow={setJoinNow}
        calendarEvents = {calendarEvents}
        handleCalendarClick = {handleCalendarClick}
      ></LatestUpcomingBlock>
      <div className="StaticInfo">
        {/* <div className="policy">
          <a href="#"><CheckIcon />{translate("class_policy")}</a>
        </div> */}
        {/* <div className="policy">
          <a href="#"><DescriptionIcon />{translate("Instrucions")}</a>
        </div>
        <div className="policy">
          <a href="#"><HelpIcon />{translate("Faq")}</a>
        </div> */}
        <div className="InfoLabel">
          <label>
            <b>{translate("SessionRating_sessionDuration")}:</b> {duration} {translate("myschedule_sessionDuraion_minutes")}
          </label>
          <label className="Communication">
            <b>{translate("myschedule_sessionDetails_communication")}:</b> {comMode}
          </label>
        </div>
        <Select className="session-filter" id="SessionFilterId" value={records} onChange={handeRecords}>
          <MenuItem value={"All sessions"}>{translate("myschedule_sessionDetails_allSessions")}</MenuItem>
          <MenuItem value={"Upcoming sessions"}>{translate("myschedule_sessionDetails_upcomingSessions")}</MenuItem>
          <MenuItem value={"Past sessions"}>{translate("myschedule_sessionDetails_pastSessions")}</MenuItem>
        </Select>
      </div>
      {records === "All sessions" && (
        <AllSessionBlock UpcomingData={AllSessionData} records={records} handleDispatch={handleDispatch}></AllSessionBlock>
      )}
      {records === "Upcoming sessions" && (
        <AllSessionBlock UpcomingData={UpcomingData} records={records} handleDispatch={handleDispatch}></AllSessionBlock>
      )}
      {records === "Past sessions" && <AllSessionBlock UpcomingData={PastData} records={records} handleDispatch={handleDispatch}></AllSessionBlock>}
      {ratingPopup && (
        <SessionRatingPopup
          sessionRating={sessionRatingProps}
          setRatingPopup={setRatingPopup}
          StarRating={sessionRatingProps.Rating}
        ></SessionRatingPopup>
      )}
      <Loader showLoader={loaderFlag} />
      <Toaster
        open={toastOptions.toastOpen}
        severity={toastOptions.toastSeverity}
        toasterClosed={toasterHandle}
        messageKey={toastOptions.toastMessageKey}
      />


    </React.Fragment>

  ) : (< React.Fragment > <ErrorPage status={status} />
    <Loader showLoader={loaderFlag} />
    <Toaster
      open={toastOptions.toastOpen}
      severity={toastOptions.toastSeverity}
      toasterClosed={toasterHandle}
      messageKey={toastOptions.toastMessageKey}
    />
  </React.Fragment >);
};

export default PastAndUpcomingSessions;
